import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    companyname: "",
    mobileno: "",
    reasonforcontact: "",
    additionaldetails: "",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_URL;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}contactus`, formData);
      if (response.status === 201) {
        alert("Form submitted successfully!");
        navigate("/");
      } else {
        alert("Failed to submit the form. Please try again.");
      }
    } catch (error) {
      alert(Error, `${error.response?.data?.error || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Page Title Section */}
      <section
              className="page-title"
              style={{ backgroundImage: `url(/images/contact.jpeg)` }}
            >
              <div className="auto-container">
                <h2>Contact Us</h2>
                <ul className="page-breadcrumb">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li> / Contact Us</li>
                </ul>
              </div>
            </section>
     
      <section className="contact-form-section">
        <div className="auto-container">
          <div className="sec-title">
            <h2>Get In Touch</h2>
            <p>
              Have questions or feedback? Reach out to us using the form below,
              and we’ll respond as soon as possible.
            </p>
          </div>

          <div className="row clearfix">
            {/* Form Column */}
            <div className="col-lg-7">
              <div className="p-4 shadow rounded bg-white">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    {/* Name Field */}
                    <div className="col-md-6">
                      <label htmlFor="name" className="form-label">
                        Name
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        required
                        value={formData.name}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Email Field */}
                    <div className="col-md-6 mt-2">
                      <label htmlFor="email" className="form-label">
                        Email Address
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        required
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Company Name Field */}
                    <div className="col-md-6 mt-2">
                      <label htmlFor="companyname" className="form-label">
                        Company Name
                      </label>
                      <input
                        type="text"
                        id="companyname"
                        name="companyname"
                        className="form-control"
                        value={formData.companyname}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Mobile Number Field */}
                    <div className="col-md-6 mt-2">
                      <label htmlFor="mobileno" className="form-label">
                        Mobile Number
                      </label>
                      <input
                        type="tel"
                        id="mobileno"
                        name="mobileno"
                        className="form-control"
                        required
                        value={formData.mobileno}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Reason for Contact */}
                    <div className="col-12 mt-2">
                      <label htmlFor="reasonforcontact" className="form-label">
                        Reason for Contact
                      </label>
                      <input
                        type="text"
                        id="reasonforcontact"
                        name="reasonforcontact"
                        className="form-control"
                        required
                        value={formData.reasonforcontact}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Additional Details */}
                    <div className="col-12 mt-2">
                      <label htmlFor="additionaldetails" className="form-label">
                        Additional Details
                      </label>
                      <textarea
                        id="additionaldetails"
                        name="additionaldetails"
                        className="form-control"
                        required
                        value={formData.additionaldetails}
                        onChange={handleInputChange}
                        rows="4"
                      ></textarea>
                    </div>

                    {/* Submit Button */}
                    <div className="col-12 text-center mt-3">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg px-5"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit Now"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* Info Column */}
            <div className="info-column col-lg-5 col-md-12 col-sm-12">
              <div className="inner-column">
                <ul className="contact-info-list">
                  <li>
                    <strong>Address :</strong>
                    <br /> Unit No. 38, Madhuban Ind Est, Near Paper Box, MIDC,
                    Andheri(East), Mumbai - 400 093
                  </li>
                </ul>
                <ul className="contact-info-list">
                  <li>
                    <strong>Phone : </strong>
                    <a href="tel:+91 9920897971">+91 9920897971</a>
                  </li>
                  <li>
                    <strong>Email : </strong>
                    <a href="mailto:vamajewelslimited@gmail.com">
                      vamajewelslimited@gmail.com
                    </a>
                  </li>
                </ul>
                <ul className="contact-info-list">
                  <li>
                    <strong>Opening Hours :</strong>
                    <br />
                    8:00 AM – 10:00 PM <br /> Monday – Sunday
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;